export default class PeriodoLetivo {
    constructor({
        ano,
        dataInicio,
        dataFim,
        dataInicioRematricula,
        dataFimRematricula,
        anoLetivoAntecessorId,
        grupoTurmaLimiteIntegralId = null,
        grupoTurmaIntegralDestinoId = null,
        avaliacaoFinal = null,
        segmentacoes,
        turmas,
        tipoAvaliacoes,
        flagCriarPeriodoFinanceiro,
        criarPeriodoFinanceiroRequest,
    }) {
        this.ano = ano;
        this.dataInicio = dataInicio;
        this.dataFim = dataFim;
        this.dataInicioRematricula = dataInicioRematricula;
        this.dataFimRematricula = dataFimRematricula;
        this.anoLetivoAntecessorId = anoLetivoAntecessorId;
        this.grupoTurmaLimiteIntegralId = grupoTurmaLimiteIntegralId;
        this.grupoTurmaIntegralDestinoId = grupoTurmaIntegralDestinoId;
        this.avaliacaoFinal = avaliacaoFinal;
        this.segmentacoes = segmentacoes;
        this.turmas = turmas;
        this.tipoAvaliacoes = tipoAvaliacoes;
        this.flagCriarPeriodoFinanceiro = flagCriarPeriodoFinanceiro;
        this.criarPeriodoFinanceiroRequest = criarPeriodoFinanceiroRequest;
    }
}